import { getEvents, useEvents, Search, Response } from "../../../hooks/useEvents";

export type { Search, Response };
export { getEvents, useEvents };

export async function Submit(search: Search|null, page = 1): Promise<Response> {
  const response = await getEvents(search, page);
  
  if (!response?.results) return {
    results: [],
    pagination: {
      page: 0,
      pageCount: 0,
      pageSize: 100,
      total: 0
    }
  };

  return {
    results: response?.results,
    pagination: response?.pagination
  };
}